import { saveWhatsappBotSetting } from '@services/WhatsappBotSettingService'
import { useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Update from './Update'

export const WhatsappBotSettingForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { error } = useAppSelector((state) => state.setting)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          update: Update,
        }}
        handlers={{
          update: async (values) => {
            return saveWhatsappBotSetting(values)
          },
        }}
      />
    )
  }
)

WhatsappBotSettingForm.displayName = 'WhatsappBotSettingForm'

export default WhatsappBotSettingForm
